import React from "react";

import StrokeButton1Img from '../images/stroke-button-1.png';
import StrokeButton2Img from '../images/stroke-button-2.png';
import StrokeButton3Img from '../images/stroke-button-3.png';
import StrokeButton1HoverImg from '../images/stroke-button-1--hover.png';
import StrokeButton2HoverImg from '../images/stroke-button-2--hover.png';
import StrokeButton3HoverImg from '../images/stroke-button-3--hover.png';
import SpStrokeButton1Img from '../images/sp/stroke-button-1.png';
import SpStrokeButton2Img from '../images/sp/stroke-button-2.png';
import SpStrokeButton3Img from '../images/sp/stroke-button-3.png';
import SpStrokeButton1HoverImg from '../images/sp/stroke-button-1--hover.png';
import SpStrokeButton2HoverImg from '../images/sp/stroke-button-2--hover.png';
import SpStrokeButton3HoverImg from '../images/sp/stroke-button-3--hover.png';
import {Store} from "../models/Store";

export const StrokeButton = (props: {
    id: number,
    onClick: (args: any) => void,
    strokeWidth: number
}) => {

    let b1:any,b1h:any,b2:any,b2h:any,b3:any,b3h:any;
    if(Store.isDeviceMobile){
        b1 = SpStrokeButton1Img;
        b2 = SpStrokeButton2Img;
        b3 = SpStrokeButton3Img;
        b1h = SpStrokeButton1HoverImg;
        b2h = SpStrokeButton2HoverImg;
        b3h = SpStrokeButton3HoverImg;
    }else{
        b1 = StrokeButton1Img;
        b2 = StrokeButton2Img;
        b3 = StrokeButton3Img;
        b1h = StrokeButton1HoverImg;
        b2h = StrokeButton2HoverImg;
        b3h = StrokeButton3HoverImg;
    }

    switch (props.id) {
        case 1:
            return <img src={props.strokeWidth===1?b1h:b1}
                        onMouseOver={e => e.currentTarget.src = b1h}
                        onMouseOut={e => e.currentTarget.src = props.strokeWidth===1?b1h:b1}
                        onClick={()=> props.onClick(props.id)}
                        className='stroke-button-1'
                        alt=""/>;
        case 2:
            return <img src={props.strokeWidth===2?b2h:b2}
                        onMouseOver={e => e.currentTarget.src = b2h}
                        onMouseOut={e => e.currentTarget.src = props.strokeWidth===2?b2h:b2}
                        onClick={()=> props.onClick(props.id)}
                        className='stroke-button-2'
                        alt=""/>;
        case 3:
            return <img src={props.strokeWidth===3?b3h:b3}
                        onMouseOver={e => e.currentTarget.src = b3h}
                        onMouseOut={e => e.currentTarget.src = props.strokeWidth===3?b3h:b3}
                        onClick={()=> props.onClick(props.id)}
                        className='stroke-button-3'
                        alt=""/>;
        default:
            throw new Error();
    }
};